// extracted by mini-css-extract-plugin
module.exports = {"shoes_matching_wrapper":"ProductMatching_shoes_matching_wrapper__CziPB","shoes_matching":"ProductMatching_shoes_matching__E3kh_","shoe_item":"ProductMatching_shoe_item__38FWI"};